/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Container = styled.div`
  background: ${Palette.PrimaryGray._000};
  border: 1px solid ${Palette.PrimaryGray._200};
  border-top: none;
  min-height: 56px;
  padding: 12px 16px 12px 8px;
  display: ${({ isHide }) => (isHide ? 'none' : 'flex')};

  justify-content: space-between;
`;

export const WrapperBox = styled.div`
  position: relative;
  display: flex;
  width: 100%;
`;

export const Box = styled.div`
  display: flex;
  width: calc(100% - 65px);
  flex-wrap: wrap;
  height: ${({ height }) => `${height}`};
  overflow-y: hidden;
`;

export const Item = styled.div`
  border-radius: 4px;
  border: 1px solid ${Palette.PrimaryGray._200};
  background: var(--White, #fff);
  width: fit-content;
  max-width: 250px;
  height: 32px;
  line-height: 32px;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 0 0px 8px;
  gap: 4px;
  user-select: none;
`;

export const CountryNameBox = styled.div`
  width: 65%;
`;

export const IconWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  :active {
    svg {
      fill: ${Palette.Primary._500};
    }
  }
  svg {
    fill: ${Palette.PrimaryGray._400};
    min-width: 16px;
    min-height: 16px;
    margin: 8px;
  }
`;

export const PlusBtnWrap = styled.div`
  position: absolute;
  top: 0;
  ${({ leftPos }) => {
    return css`
      left: ${leftPos}px;
    `;
  }}
`;

export const ShowLessBtnWrap = styled.div`
  position: absolute;
  bottom: 8px;
  ${({ leftPos }) => {
    return css`
      left: ${leftPos}px;
    `;
  }}
`;

export const WrapItem = styled.div`
  //border: 1px solid blue;
  padding-right: 8px;
  padding-bottom: 8px;
`;
